module.exports = __webpack_public_path__ + "img/F-22.0b422562.png";